module.exports = __webpack_public_path__ + "img/bandaoti_juruixing.5aed2abb.png";